import React from "react";
import PropTypes from "prop-types";
import { intlShape } from "react-intl";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { COLORS } from "./constants";
import StandardMoney from "../../../common/StandardMoney";
import messages from "../../../messagesDescription";

const innerCircleStyle = {
  textAlign: "center",
  width: "140px",
  height: "140px",
  color: "white",
  backgroundColor: "black",
  borderRadius: "70px",
  position: "relative",
  top: "35px",
  left: "35px",
  lineHeight: "1.8em",
  fontSize: "0.75em",
};

const chartContainerStyle = {
  width: "220px",
  marginLeft: "auto",
  marginRight: "auto",
};

const TrsPieChart = ({ data, currencyCode, intl }) => {
  if (Array.isArray(data.categorySummaries) && data.categorySummaries.length <= 0)
    return <p>{intl.formatMessage({ ...messages.noTotalRewards })}</p>;

  let pieData = [];
  Array.isArray(data.categorySummaries) &&
    data.categorySummaries.forEach(item => {
      if (Number(item.entitlement) > 0) {
        pieData.push({ name: item.categoryName, value: Number(item.entitlement) });
      } else {
        pieData.push({ name: item.categoryName, value: 0 });
      }
    });

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div style={{ color: "black", backgroundColor: "white" }}>
          <span>{`${payload[0].name} :`}</span>{" "}
          <StandardMoney value={payload[0].value} currency={currencyCode} />
        </div>
      );
    }
    return null;
  };

  CustomTooltip.propTypes = {
    active: PropTypes.bool,
    payload: PropTypes.array,
  };

  return (
    <div style={chartContainerStyle}>
      {data.categorySummaries && (
        <div style={innerCircleStyle}>
          <br />
          Total Rewards <br />
          <StandardMoney value={data.totalRewards} currency={currencyCode} /> <br />
          {Number(data.totalRewardsPercentage)}% <br />
          of my base Salary
        </div>
      )}
      <div style={{ position: "relative", top: "-140px" }}>
        <PieChart width={220} height={220}>
          <Pie data={pieData} cx={100} cy={100} innerRadius={80} outerRadius={100} dataKey="value">
            {pieData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
        <p style={{ textAlign: "center", fontSize: "0.75em" }}>
          As of {data.referenceDate}
          <br /> All figures are in {currencyCode}
        </p>
      </div>
    </div>
  );
};

TrsPieChart.propTypes = {
  data: PropTypes.object,
  currencyCode: PropTypes.string,
  intl: intlShape.isRequired,
};

export default TrsPieChart;



// WEBPACK FOOTER //
// ./components/employee/benefits/trs/PieChart.jsx